export default "__VITE_ASSET__0993ea48__"